// Router der App. Ohne `.vue`-Import (die Routen-Tabelle steht in `routes.ts`), damit Tests ihn mit
// Stub-Komponenten bauen können.
//
// EIN Schreiber je URL-Teil (kritisch – nicht aufweichen): die Datei-Keys (`DOC_QUERY_KEYS`)
// schreibt nur `useWorkingDocUrlState`, Pfad und übrige Query nur der Router. Deshalb wird
// `route.query` beim Navigieren NIE gespreadet – es hält veraltete Datei-Werte, weil der
// Datei-Schreiber am Router vorbei schreibt. Der `afterEach` unten ist die einzige Brücke.

import {createRouter, createWebHistory, type RouteRecordRaw, type RouterHistory} from 'vue-router';

import {mirrorWorkingDocToUrl} from '@/composables/useWorkingDocUrlState';

export function createAppRouter(routes: RouteRecordRaw[], history: RouterHistory = createWebHistory()) {
    const router = createRouter({history, routes});

    // Nach JEDER Navigation den Datei-Stand des Speichers in die URL spiegeln: eine Navigation ohne
    // Datei-Keys (Tab-Link, Akkord-Auswahl) bekommt sie so zurück, und nach Zurück/Vor steht nicht
    // die Datei des alten History-Eintrags in der URL, während im Speicher eine andere geladen ist –
    // ein Reload stellte sonst die falsche Linie her.
    router.afterEach(() => mirrorWorkingDocToUrl());

    return router;
}
